/**
 * Takes a react-hook-form errors object and returns an array of error messages
 */
export const extractErrors = (errors: object): { message: string }[] => {
    return Object.entries(errors).reduce((acc, [_key, value]) => {
        if (value instanceof Object && 'message' in value) {
            return [...acc, value];
        }
        return [...acc, ...extractErrors(value)];
    }, []);
};
